// extracted by mini-css-extract-plugin
export default {"divider":"_3e23f452f6763698013d530127444e92"};